import { useContext } from "react";
import { CustomerContext } from "../contexts";

const useCustomer = () => {
  return useContext(CustomerContext);
};

export default useCustomer;
